export const PATHS = {
  CONFIRM_EMAIL: 'confirm-email',
  PASSWORD_RECOVERY: 'password-recovery',
  PRE_APPROVAL: 'pre-approval',
  PROOF_DOCUMENTS: 'proof-documents',
  PROFILE: 'profile',
  REQUISITION: 'requisition',
  CANCELLED_REQUISITION: 'cancelled-requisition',
  REFERENCES: 'references',
  CLABE: 'clabe',
};
